// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__VXs1Y","track":"Switch_track__1Sc7D","text":"Switch_text__w1+ip","optionHint":"Switch_optionHint__wCsHA"};